// Exchange Product Grid Filtering - Multi-select Support v2.1
document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.exchange-product-card');
  const filterHeaders = document.querySelectorAll('.filter-header');
  const pageType = document.querySelector('.filters-sidebar')?.dataset.pageType;
  const clearAllBtn = document.getElementById('clearAllFiltersBtn');
  const sortSelect = document.getElementById('sortSelect');
  const itemsPerPageSelect = document.getElementById('itemsPerPage');
  
  // Multi-select: each filter group stores an array of selected values
  let activeFilters = {};
  let currentSort = 'latest';
  let itemsPerPage = parseInt(itemsPerPageSelect?.value || '12');
  let currentPage = 1;
  let allProducts = Array.from(productCards);

  // Mobile filter functionality
  setupMobileFilters();
  
  buildFilterOptions();
  setupAccordion();
  setupFilterHandlers();
  setupClearAllButton();
  setupSortControls();
  setupPaginationControls();
  setupSearchIntegration();
  
  // Show loader and apply collection filters with delay
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('collection')) {
    showFilterLoader();
    setTimeout(() => {
      applyCollectionFilters();
      hideFilterLoader();
    }, 1000);
  }
  
  function showFilterLoader() {
    const grid = document.getElementById('product-grids');
    if (!grid) return;
    const loader = document.createElement('div');
    loader.id = 'filter-loader';
    loader.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:9999;background:rgba(255,255,255,0.95);padding:2rem;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15)';
    loader.innerHTML = '<div style="text-align:center"><div style="border:3px solid #f3f3f3;border-top:3px solid #3751FF;border-radius:50%;width:40px;height:40px;animation:spin 1s linear infinite;margin:0 auto"></div><p style="margin-top:1rem;color:#374151;font-family:Rubik,sans-serif">Preparing Collection</p></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>';
    document.body.appendChild(loader);
  }
  
  function hideFilterLoader() {
    const loader = document.getElementById('filter-loader');
    if (loader) loader.remove();
  }
  
  // Listen for complete product data from collection-realtime-search.js
  document.addEventListener('allProductsLoaded', function(event) {
    // Update allProducts to current DOM state (all products should be loaded)
    allProducts = Array.from(document.querySelectorAll('.exchange-product-card'));
    
    // Rebuild filters from all loaded DOM products
    buildFilterOptions();
    
    // Update pagination with actual DOM count
    updateResultsCount(allProducts.length, '');
    renderPagination(allProducts.length);
  });
  
  // Listen for DOM products loaded event from load-all-products.js
  document.addEventListener('allProductsLoadedInDOM', function(event) {
    // Update allProducts array with all DOM products
    allProducts = Array.from(document.querySelectorAll('.exchange-product-card'));
    
    // Rebuild filters from all loaded DOM products
    buildFilterOptions();
    
    // Recalculate pagination with all products
    currentPage = 1;
    showPage(currentPage);
    updateResultsCount(allProducts.length, '');
    renderPagination(allProducts.length);
  });
  
  // Initial sort by latest (created date)
  sortProducts('latest');
  
  // Initialize with first page showing
  setTimeout(() => {
    showPage(1);
    updateResultsCount(allProducts.length, '');
    renderPagination(allProducts.length);
  }, 100);

  function buildFilterOptions() {
    const filterValues = {};
    const filterMapping = {
      apps: {
        apptype: 'apptype',
        category: 'category',
        pricetype: 'pricetype',
        developer: 'developer',
        saviyntproduct: 'saviyntproduct'
      },
      solutions: {
        region: 'region',
        partner: 'partner',
        saviyntproduct: 'saviyntproduct',
        industry: 'industry',
        solutiontype: 'solutiontype'
      }
    };
    
    const currentFilters = filterMapping[pageType] || {};
    Object.keys(currentFilters).forEach(key => filterValues[key] = new Set());

    productCards.forEach(card => {
      const productCard = card.querySelector('[data-product-id]') || card;
      Object.entries(currentFilters).forEach(([filterKey, dataAttr]) => {
        const value = productCard.dataset[dataAttr];
        if (value && value.trim() !== '' && value !== 'undefined' && value !== 'null') {
          if (value.includes(',')) {
            value.split(',').forEach(v => {
              const trimmed = v.trim();
              if (trimmed && trimmed !== 'undefined' && trimmed !== 'null') {
                filterValues[filterKey].add(trimmed);
              }
            });
          } else {
            const trimmed = value.trim();
            if (trimmed && trimmed !== 'undefined' && trimmed !== 'null') {
              filterValues[filterKey].add(trimmed);
            }
          }
        }
      });
    });


    Object.entries(filterValues).forEach(([filterKey, valuesSet]) => {
      const filterList = document.querySelector(`#${filterKey} .filter-options-list`);
      const filterSection = document.querySelector(`[data-toggle="${filterKey}"]`)?.closest('.filter-section');
      if (!filterList) return;
      
      // Clear existing options except "All"
      const existingOptions = filterList.querySelectorAll('.filter-option:not([data-filter="all"])');
      existingOptions.forEach(option => option.remove());
      
      const values = Array.from(valuesSet).sort();
      if (values.length === 0 && filterSection) {
        filterSection.style.display = 'none';
        return;
      } else if (filterSection) {
        filterSection.style.display = 'block';
      }
      
      if (values.length > 10) {
        const filterContent = filterList.closest('.filter-content');
        if (filterContent && !filterContent.querySelector('.filter-search-input')) {
          const searchInput = document.createElement('input');
          searchInput.type = 'text';
          searchInput.className = 'filter-search-input';
          searchInput.dataset.filterSearch = filterKey;
          searchInput.placeholder = 'Search...';
          filterContent.insertBefore(searchInput, filterList);
          
          searchInput.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase().trim();
            filterList.querySelectorAll('.filter-option').forEach(option => {
              if (option.dataset.filter === 'all') {
                option.style.display = 'block';
                return;
              }
              option.style.display = option.textContent.toLowerCase().includes(searchTerm) ? 'block' : 'none';
            });
          });
        }
        filterList.classList.add('scrollable');
      }

      values.forEach(value => {
        const button = document.createElement('button');
        button.className = 'filter-option';
        button.dataset.filter = value;
        button.dataset.group = filterKey;
        button.textContent = value;
        filterList.appendChild(button);
      });
    });
    
    setupFilterHandlers();
  }

  function setupAccordion() {
    filterHeaders.forEach(header => {
      header.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.dataset.toggle;
        const content = document.getElementById(targetId);
        if (content) {
          content.classList.toggle('show');
          this.classList.toggle('active');
        }
      });
    });
  }

  function setupFilterHandlers() {
    document.querySelectorAll('.filter-option').forEach(option => {
      const newOption = option.cloneNode(true);
      option.parentNode.replaceChild(newOption, option);
      
      newOption.addEventListener('click', function() {
        const filterGroup = this.dataset.group;
        const filterValue = this.dataset.filter;
        
        if (filterValue === 'all') {
          // Clear all selections in this group
          delete activeFilters[filterGroup];
          document.querySelectorAll(`[data-group="${filterGroup}"]`).forEach(btn => {
            btn.classList.remove('active');
          });
          this.classList.add('active');
        } else {
          // Multi-select toggle
          if (!activeFilters[filterGroup]) {
            activeFilters[filterGroup] = [];
          }
          
          const index = activeFilters[filterGroup].indexOf(filterValue);
          if (index > -1) {
            // Remove if already selected
            activeFilters[filterGroup].splice(index, 1);
            this.classList.remove('active');
            
            // If no selections left, show "All" as active
            if (activeFilters[filterGroup].length === 0) {
              delete activeFilters[filterGroup];
              const allBtn = document.querySelector(`[data-group="${filterGroup}"][data-filter="all"]`);
              if (allBtn) allBtn.classList.add('active');
            }
          } else {
            // Add to selection
            activeFilters[filterGroup].push(filterValue);
            this.classList.add('active');
            
            // Remove "All" active state
            const allBtn = document.querySelector(`[data-group="${filterGroup}"][data-filter="all"]`);
            if (allBtn) allBtn.classList.remove('active');
          }
        }
        
        // Keep accordion open when filter applied
        const header = document.querySelector(`[data-toggle="${filterGroup}"]`);
        const content = document.getElementById(filterGroup);
        if (activeFilters[filterGroup]?.length > 0 && header && content) {
          header.classList.add('active');
          content.classList.add('show');
        }
        
        updateFilterHeaderIndicators();
        currentPage = 1;
        filterProducts();
      });
    });
  }

  function filterProducts() {
    let visibleCards = [];
    const searchInput = document.querySelector('.hero-search-input');
    const searchQuery = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const hasActiveFilters = Object.keys(activeFilters).length > 0;
    const paginationControls = document.querySelector('.pagination-controls');
    
    // If no search and no filters, show original pagination behavior
    if (!searchQuery && !hasActiveFilters) {
      if (paginationControls) paginationControls.style.display = 'block';
      visibleCards = allProducts;
      currentPage = 1;
      showPage(currentPage);
      updateResultsCount(allProducts.length, '');
      renderPagination(allProducts.length);
      return;
    }
    
    // Filter products
    allProducts.forEach(card => {
      const pc = card.querySelector('[data-product-id]') || card;
      
      const data = {
        developer: (pc.dataset.developer || '').trim(),
        appType: (pc.dataset.apptype || '').trim(),
        category: (pc.dataset.category || '').trim(),
        priceType: (pc.dataset.pricetype || '').trim(),
        saviyntProduct: (pc.dataset.saviyntproduct || '').trim(),
        certified: pc.dataset.certified || '',
        region: (pc.dataset.region || '').trim(),
        partner: (pc.dataset.partner || '').trim(),
        industry: (pc.dataset.industry || '').trim(),
        solutionType: (pc.dataset.solutiontype || '').trim()
      };
      
      // Check filter match (multi-select: OR within group, AND between groups)
      let filterMatch = true;
      for (const [group, values] of Object.entries(activeFilters)) {
        if (!values || values.length === 0) continue;
        
        let groupMatch = false;
        
        if (group === 'certified') {
          // Special handling for certified (Yes/No)
          groupMatch = values.some(v => {
            if (v === 'true') return data.certified === 'true';
            if (v === 'false') return data.certified === 'false' || data.certified === '';
            return false;
          });
        } else {
          // Map filter group to data attribute
          const dataAttrMap = {
            'apptype': 'appType',
            'pricetype': 'priceType', 
            'saviyntproduct': 'saviyntProduct',
            'solutiontype': 'solutionType'
          };
          const dataKey = dataAttrMap[group] || group;
          
          // Multi-select: match ANY of the selected values (OR logic)
          groupMatch = values.some(v => {
            const filterValue = v.trim();
            const dataValue = data[dataKey];
            
            if (!dataValue) return false;
            
            // Handle comma-separated values in data attributes
            if (dataValue.includes(',')) {
              const dataValues = dataValue.split(',').map(val => val.trim());
              return dataValues.some(dv => dv === filterValue);
            }
            
            return dataValue === filterValue;
          });
        }
        
        if (!groupMatch) {
          filterMatch = false;
          break;
        }
      }
      
      // Check search match (case-insensitive for search only)
      let searchMatch = true;
      if (searchQuery) {
        const title = (card.querySelector('.product-title')?.textContent || '').toLowerCase();
        const vendor = (card.querySelector('.product-vendor')?.textContent || '').toLowerCase();
        const description = (card.querySelector('.product-description')?.textContent || '').toLowerCase();
        searchMatch = title.includes(searchQuery) || vendor.includes(searchQuery) || description.includes(searchQuery);
      }
      
      const shouldShow = filterMatch && searchMatch;
      
      if (shouldShow) {
        visibleCards.push(card);
      }
    });
    
    // Show pagination controls
    if (paginationControls) paginationControls.style.display = 'block';
    
    // Hide all products first
    allProducts.forEach(card => card.style.display = 'none');
    
    // Show only filtered products with pagination
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    
    visibleCards.forEach((card, index) => {
      if (index >= startIndex && index < endIndex) {
        card.style.display = 'block';
      }
    });
    
    updateResultsCount(visibleCards.length, searchQuery);
    renderPagination(visibleCards.length);
    
    // Store filtered cards for pagination
    window.filteredCards = visibleCards;
  }
  
  function updateResultsCount(count, searchQuery) {
    const resultsCount = document.getElementById('resultsCount');
    const resultsCountTop = document.getElementById('resultsCountTop');
    if (!resultsCount && !resultsCountTop) return;
    
    const hasFilters = Object.keys(activeFilters).length > 0;
    const hasSearch = searchQuery && searchQuery.length > 0;
    
    let text = `Showing ${count} result${count !== 1 ? 's' : ''}`;
    if (hasFilters || hasSearch) {
      if (hasSearch) text += ` for "${searchQuery}"`;
    }
    
    if (resultsCount) resultsCount.textContent = text;
    if (resultsCountTop) resultsCountTop.textContent = text;
  }
  
  function updateFilterHeaderIndicators() {
    filterHeaders.forEach(header => {
      const id = header.dataset.toggle;
      const hasFilter = activeFilters[id] && activeFilters[id].length > 0;
      
      if (hasFilter) {
        header.classList.add('has-active-filter');
        // Show count badge
        let badge = header.querySelector('.filter-count-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'filter-count-badge';
          header.querySelector('span').appendChild(badge);
        }
        badge.textContent = activeFilters[id].length;
      } else {
        header.classList.remove('has-active-filter');
        const badge = header.querySelector('.filter-count-badge');
        if (badge) badge.remove();
      }
    });
    
    updateClearAllButtonVisibility();
  }
  
  function setupClearAllButton() {
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', clearAllFilters);
    }
  }
  
  function updateClearAllButtonVisibility() {
    if (clearAllBtn) {
      const hasActiveFilters = Object.keys(activeFilters).length > 0;
      clearAllBtn.style.display = hasActiveFilters ? 'inline-flex' : 'none';
    }
  }
  
  function clearAllFilters() {
    activeFilters = {};
    window.filteredCards = null;
    
    document.querySelectorAll('.filter-option').forEach(option => {
      option.classList.remove('active');
      if (option.dataset.filter === 'all') option.classList.add('active');
    });
    
    document.querySelectorAll('.filter-search-input').forEach(input => {
      input.value = '';
    });
    
    filterHeaders.forEach(header => {
      header.classList.remove('active', 'has-active-filter');
      const badge = header.querySelector('.filter-count-badge');
      if (badge) badge.remove();
      const content = document.getElementById(header.dataset.toggle);
      if (content) content.classList.remove('show');
    });
    
    updateClearAllButtonVisibility();
    currentPage = 1;
    filterProducts();
  }

  function setupSortControls() {
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        currentSort = this.value;
        sortProducts(currentSort);
        currentPage = 1;
        showPage(currentPage);
        renderPagination(allProducts.length);
      });
    }
  }
  
  function setupPaginationControls() {
    if (itemsPerPageSelect) {
      // Set initial value
      itemsPerPageSelect.value = itemsPerPage.toString();
      
      itemsPerPageSelect.addEventListener('change', function() {
        itemsPerPage = parseInt(this.value);
        currentPage = 1;
        const hasActiveFilters = Object.keys(activeFilters).length > 0;
        const searchInput = document.querySelector('.hero-search-input');
        const searchQuery = searchInput ? searchInput.value.toLowerCase().trim() : '';
        
        if (!searchQuery && !hasActiveFilters) {
          showPage(currentPage);
          renderPagination(allProducts.length);
        } else {
          filterProducts();
        }
      });
    }
  }
  
  function showPage(page) {
    const cardsToShow = window.filteredCards || allProducts;
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    
    allProducts.forEach(card => card.style.display = 'none');
    
    cardsToShow.forEach((card, index) => {
      if (index >= startIndex && index < endIndex) {
        card.style.display = 'block';
      }
    });
    
    currentPage = page;
  }
  
  function sortProducts(sortType) {
    const grid = document.getElementById('product-grids');
    if (!grid) return;
    
    allProducts.sort((a, b) => {
      const titleA = (a.querySelector('.product-title')?.textContent || '').trim();
      const titleB = (b.querySelector('.product-title')?.textContent || '').trim();
      
      if (sortType === 'az') {
        return titleA.localeCompare(titleB);
      } else if (sortType === 'za') {
        return titleB.localeCompare(titleA);
      } else if (sortType === 'latest') {
        // Sort by created date (newest first)
        const dateA = a.dataset.createdAt || a.querySelector('[data-created-at]')?.dataset.createdAt || '';
        const dateB = b.dataset.createdAt || b.querySelector('[data-created-at]')?.dataset.createdAt || '';
        
        if (dateA && dateB) {
          return new Date(dateB) - new Date(dateA); // Newest first
        }
        return 0;
      }
      
      return 0;
    });
    
    // Re-append in sorted order
    allProducts.forEach(card => grid.appendChild(card));
  }
  
  function renderPagination(totalVisible) {
    const paginationButtons = document.getElementById('paginationButtons');
    if (!paginationButtons) {
      return;
    }
    
    const totalPages = Math.ceil(totalVisible / itemsPerPage);
    
    if (totalPages <= 1) {
      paginationButtons.innerHTML = '';
      return;
    }
    
    let html = '';
    
    // Check if mobile
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Mobile: Only Previous, Current Page, Next
      html += `<button class="pagination-btn" data-page="prev" ${currentPage === 1 ? 'disabled' : ''} style="padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151; ${currentPage === 1 ? 'opacity: 0.5; cursor: not-allowed;' : ''}">‹</button>`;
      
      html += `<span style="padding: 8px 12px; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151; font-weight: 600;">${currentPage} / ${totalPages}</span>`;
      
      html += `<button class="pagination-btn" data-page="next" ${currentPage === totalPages ? 'disabled' : ''} style="padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151; ${currentPage === totalPages ? 'opacity: 0.5; cursor: not-allowed;' : ''}">›</button>`;
    } else {
      // Desktop: Full pagination
      html += `<button class="pagination-btn" data-page="prev" ${currentPage === 1 ? 'disabled' : ''} style="padding: 0.5rem 0.75rem; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151; ${currentPage === 1 ? 'opacity: 0.5; cursor: not-allowed;' : ''}">Previous</button>`;
      
      const maxVisible = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      let endPage = Math.min(totalPages, startPage + maxVisible - 1);
      
      if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
      }
      
      if (startPage > 1) {
        html += `<button class="pagination-btn" data-page="1" style="padding: 0.5rem 0.75rem; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151;">1</button>`;
        if (startPage > 2) {
          html += `<span style="padding: 0.5rem; color: #9ca3af;">...</span>`;
        }
      }
      
      for (let i = startPage; i <= endPage; i++) {
        const isActive = i === currentPage;
        html += `<button class="pagination-btn ${isActive ? 'active' : ''}" data-page="${i}" style="padding: 0.5rem 0.75rem; border: 1px solid ${isActive ? '#374151' : '#e5e7eb'}; border-radius: 6px; background: ${isActive ? '#374151' : 'white'}; color: ${isActive ? 'white' : '#374151'}; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: ${isActive ? '600' : '400'};">${i}</button>`;
      }
      
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          html += `<span style="padding: 0.5rem; color: #9ca3af;">...</span>`;
        }
        html += `<button class="pagination-btn" data-page="${totalPages}" style="padding: 0.5rem 0.75rem; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151;">${totalPages}</button>`;
      }
      
      html += `<button class="pagination-btn" data-page="next" ${currentPage === totalPages ? 'disabled' : ''} style="padding: 0.5rem 0.75rem; border: 1px solid #e5e7eb; border-radius: 6px; background: white; cursor: pointer; font-family: 'Rubik', sans-serif; font-size: 14px; color: #374151; ${currentPage === totalPages ? 'opacity: 0.5; cursor: not-allowed;' : ''}">Next</button>`;
    }
    
    paginationButtons.innerHTML = html;
    
    // Attach click handlers
    paginationButtons.querySelectorAll('.pagination-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.disabled) return;
        
        const page = this.dataset.page;
        const cardsToShow = window.filteredCards || allProducts;
        const totalPages = Math.ceil(cardsToShow.length / itemsPerPage);
        
        if (page === 'prev') {
          currentPage = Math.max(1, currentPage - 1);
        } else if (page === 'next') {
          currentPage = Math.min(totalPages, currentPage + 1);
        } else {
          currentPage = parseInt(page);
        }
        
        showPage(currentPage);
        renderPagination(cardsToShow.length);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
  
  function setupSearchIntegration() {
    const searchInput = document.querySelector('.hero-search-input');
    if (!searchInput) return;
    
    let searchDebounce;
    searchInput.addEventListener('input', function() {
      clearTimeout(searchDebounce);
      searchDebounce = setTimeout(function() {
        currentPage = 1;
        filterProducts();
      }, 300);
    });
  }
  
  function rebuildFiltersFromCompleteData(products) {
    const filterMapping = {
      apps: {
        apptype: 'appType',
        category: 'category', 
        pricetype: 'priceType',
        developer: 'developer',
        saviyntproduct: 'saviyntProduct'
      },
      solutions: {
        region: 'region',
        partner: 'partner',
        saviyntproduct: 'saviyntProduct', 
        industry: 'industry',
        solutiontype: 'solutionType'
      }
    };
    
    const currentFilters = filterMapping[pageType] || {};
    const filterValues = {};
    
    // Initialize filter value sets
    Object.keys(currentFilters).forEach(key => filterValues[key] = new Set());
    
    // Extract values from complete product data
    products.forEach(product => {
      Object.entries(currentFilters).forEach(([filterKey, dataAttr]) => {
        let value;
        if (dataAttr === 'developer' || dataAttr === 'partner') {
          value = product.vendor;
        } else {
          // Extract from tags or other product data
          value = extractValueFromProduct(product, dataAttr);
        }
        
        if (value && value.trim() !== '') {
          // Split comma-separated values (from multi-select metafields) into individual entries
          value.split(',').forEach(v => {
            const trimmed = v.trim();
            if (trimmed) filterValues[filterKey].add(trimmed);
          });
        }
      });
    });
    
    // Update each filter section
    Object.entries(filterValues).forEach(([filterKey, valuesSet]) => {
      const filterList = document.querySelector(`[data-filter-list="${filterKey}"]`);
      if (!filterList) return;
      
      const values = Array.from(valuesSet).sort();
      const existingOptions = filterList.querySelectorAll('.filter-option:not([data-filter="all"])');
      
      if (values.length > existingOptions.length) {
        // Remove existing non-"All" options
        existingOptions.forEach(option => option.remove());
        
        // Add complete set of options
        values.forEach(value => {
          const button = document.createElement('button');
          button.className = 'filter-option';
          button.dataset.filter = value;
          button.dataset.group = filterKey;
          button.textContent = value;
          filterList.appendChild(button);
        });
        
        // Re-setup handlers
        setupFilterHandlers();
      }
    });
  }
  
  function extractValueFromProduct(product, dataAttr) {
    // Extract metafield data from Shopify product object
    if (product.metafields && product.metafields.custom) {
      const metafields = product.metafields.custom;
      
      // Map dataAttr to actual metafield names
      const metafieldMap = {
        'appType': 'product_type_custom',
        'category': 'multicat',
        'priceType': 'price_types',
        'saviyntProduct': 'savprod',
        'region': 'region',
        'industry': 'industry',
        'solutionType': 'product_type_custom'
      };
      
      const metafieldName = metafieldMap[dataAttr];
      // Collect values from both new multi-select and old single-value fields
      const allValues = new Set();
      const toCSV = (val) => {
        if (Array.isArray(val)) return val;
        try { const p = JSON.parse(val); if (Array.isArray(p)) return p; } catch(e) {}
        return val ? val.split(',') : [];
      };
      if (metafieldName && metafields[metafieldName]) {
        toCSV(metafields[metafieldName]).forEach(v => { const t = v.trim(); if (t) allValues.add(t); });
      }
      // Also include old field values so both coexist
      const oldFields = { multicat: 'categories', savprod: 'saviynt_products' };
      if (metafieldName && oldFields[metafieldName] && metafields[oldFields[metafieldName]]) {
        toCSV(metafields[oldFields[metafieldName]]).forEach(v => { const t = v.trim(); if (t) allValues.add(t); });
      }
      if (allValues.size > 0) return Array.from(allValues).join(',');
    }
    
    // Fallback to tags if metafields not available
    const tags = product.tags || [];
    for (const tag of tags) {
      if (tag.toLowerCase().includes(dataAttr.toLowerCase())) {
        return tag;
      }
    }
    
    return '';
  }
  
  document.addEventListener('clearAllFilters', clearAllFilters);
  
  function applyCollectionFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const collectionHandle = urlParams.get('collection');
    
    if (!collectionHandle) return;
    
    // Find products from the specified collection in the DOM
    const collectionProducts = Array.from(productCards).filter(card => {
      const productCard = card.querySelector('[data-product-id]') || card;
      const productCollections = productCard.dataset.collections || '';
      return productCollections.split(',').map(c => c.trim()).includes(collectionHandle);
    });
    
    if (collectionProducts.length === 0) return;
    
    // Extract common filter values from collection products
    const filterCriteria = extractCollectionFilters(collectionProducts);
    
    // Auto-apply filters that have a single common value
    Object.entries(filterCriteria).forEach(([filterGroup, values]) => {
      if (values.size === 1) {
        const value = Array.from(values)[0];
        
        // Try exact match first
        let filterBtn = document.querySelector(`[data-group="${filterGroup}"][data-filter="${value}"]`);
        
        // If not found, try case-insensitive match
        if (!filterBtn) {
          const allBtns = document.querySelectorAll(`[data-group="${filterGroup}"]`);
          filterBtn = Array.from(allBtns).find(btn => 
            btn.dataset.filter && btn.dataset.filter.toLowerCase() === value.toLowerCase()
          );
        }
        
        if (filterBtn) {
          // Direct state management
          const filterGroup = filterBtn.dataset.group;
          const filterValue = filterBtn.dataset.filter;
          
          // Update activeFilters
          if (!activeFilters[filterGroup]) activeFilters[filterGroup] = [];
          activeFilters[filterGroup].push(filterValue);
          
          // Update UI
          filterBtn.classList.add('active');
          const allBtn = document.querySelector(`[data-group="${filterGroup}"][data-filter="all"]`);
          if (allBtn) allBtn.classList.remove('active');
        }
      }
    });
    
    // Update UI and apply filters
    if (Object.keys(activeFilters).length > 0) {
      updateFilterHeaderIndicators();
      currentPage = 1;
      filterProducts();
    }
    
    // Update results count with collection context
    const resultsCount = document.getElementById('resultsCount');
    if (resultsCount) {
      const collectionName = collectionHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      setTimeout(() => {
        const currentText = resultsCount.textContent;
        if (!currentText.includes(collectionName)) {
          resultsCount.innerHTML = `<strong>${collectionName}</strong> - ` + currentText;
        }
      }, 100);
    }
  }
  
  function extractCollectionFilters(collectionProducts) {
    const filterMapping = {
      apps: ['apptype', 'category', 'pricetype', 'developer', 'saviyntproduct'],
      solutions: ['region', 'partner', 'saviyntproduct', 'industry', 'solutiontype']
    };
    
    const relevantFilters = filterMapping[pageType] || [];
    const filterCriteria = {};
    
    relevantFilters.forEach(filterKey => {
      filterCriteria[filterKey] = new Set();
      
      collectionProducts.forEach(card => {
        const productCard = card.querySelector('[data-product-id]') || card;
        const value = productCard.dataset[filterKey];
        
        if (value && value.trim() !== '' && value !== 'undefined') {
          if (value.includes(',')) {
            value.split(',').forEach(v => {
              const trimmed = v.trim();
              if (trimmed) filterCriteria[filterKey].add(trimmed);
            });
          } else {
            filterCriteria[filterKey].add(value.trim());
          }
        }
      });
    });
    
    return filterCriteria;
  }
  
  // Export function for external use
  window.exchangeFilters = {
    rebuildFiltersFromCompleteData: rebuildFiltersFromCompleteData
  };
  
  function setupMobileFilters() {
    const mobileFilterBtn = document.getElementById('mobileFilterBtn');
    const mobileSortBtn = document.getElementById('mobileSortBtn');
    const mobileFilterModal = document.getElementById('mobileFilterModal');
    const mobileFilterClose = document.getElementById('mobileFilterClose');
    const mobileClearBtn = document.getElementById('mobileClearBtn');
    const mobileApplyBtn = document.getElementById('mobileApplyBtn');
    const desktopSidebar = document.querySelector('.filters-sidebar');
    const mobileFilterBody = document.querySelector('.mobile-filter-body');
    
    if (!mobileFilterBtn || !desktopSidebar) return;
    
    // Clone desktop filters to mobile modal
    function cloneFiltersToMobile() {
      if (mobileFilterBody && desktopSidebar) {
        mobileFilterBody.innerHTML = desktopSidebar.innerHTML;
        
        // Setup accordion functionality for cloned elements
        mobileFilterBody.querySelectorAll('.filter-header').forEach(header => {
          header.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.dataset.toggle;
            const content = mobileFilterBody.querySelector(`#${targetId}`);
            if (content) {
              content.classList.toggle('show');
              this.classList.toggle('active');
            }
          });
        });
        
        // Setup filter option handlers for cloned elements
        mobileFilterBody.querySelectorAll('.filter-option').forEach(option => {
          option.addEventListener('click', function() {
            const filterGroup = this.dataset.group;
            const filterValue = this.dataset.filter;
            
            if (filterValue === 'all') {
              // Clear all selections in this group
              delete activeFilters[filterGroup];
              mobileFilterBody.querySelectorAll(`[data-group="${filterGroup}"]`).forEach(btn => {
                btn.classList.remove('active');
              });
              this.classList.add('active');
            } else {
              // Multi-select toggle
              if (!activeFilters[filterGroup]) {
                activeFilters[filterGroup] = [];
              }
              
              const index = activeFilters[filterGroup].indexOf(filterValue);
              if (index > -1) {
                // Remove if already selected
                activeFilters[filterGroup].splice(index, 1);
                this.classList.remove('active');
                
                // If no selections left, show "All" as active
                if (activeFilters[filterGroup].length === 0) {
                  delete activeFilters[filterGroup];
                  const allBtn = mobileFilterBody.querySelector(`[data-group="${filterGroup}"][data-filter="all"]`);
                  if (allBtn) allBtn.classList.add('active');
                }
              } else {
                // Add to selection
                activeFilters[filterGroup].push(filterValue);
                this.classList.add('active');
                
                // Remove "All" active state
                const allBtn = mobileFilterBody.querySelector(`[data-group="${filterGroup}"][data-filter="all"]`);
                if (allBtn) allBtn.classList.remove('active');
              }
            }
          });
        });
      }
    }
    
    // Update mobile filter button state
    function updateMobileFilterButton() {
      const hasActiveFilters = Object.keys(activeFilters).length > 0;
      if (mobileFilterBtn) {
        mobileFilterBtn.classList.toggle('has-filters', hasActiveFilters);
      }
    }
    
    // Mobile filter button click
    mobileFilterBtn.addEventListener('click', function() {
      cloneFiltersToMobile();
      mobileFilterModal.classList.add('show');
      document.body.style.overflow = 'hidden';
    });
    
    // Mobile sort button click
    if (mobileSortBtn && sortSelect) {
      mobileSortBtn.addEventListener('click', function() {
        // Create mobile sort modal
        const sortOptions = [
          { value: 'latest', label: 'Latest' },
          { value: 'az', label: 'Alphabetical A-Z' },
          { value: 'za', label: 'Alphabetical Z-A' }
        ];
        
        const sortModal = document.createElement('div');
        sortModal.className = 'mobile-filter-modal show';
        sortModal.innerHTML = `
          <div class="mobile-filter-content">
            <div class="mobile-filter-header">
              <h3 class="mobile-filter-title">Sort By</h3>
              <button class="mobile-filter-close">&times;</button>
            </div>
            <div class="mobile-filter-body">
              ${sortOptions.map(option => `
                <button class="filter-option ${currentSort === option.value ? 'active' : ''}" data-sort="${option.value}" style="width: 100%; text-align: left; padding: 12px; margin-bottom: 8px; border: 1px solid #e5e7eb; border-radius: 6px; background: ${currentSort === option.value ? '#3751FF' : 'white'}; color: ${currentSort === option.value ? 'white' : '#374151'};">
                  ${option.label}
                </button>
              `).join('')}
            </div>
          </div>
        `;
        
        document.body.appendChild(sortModal);
        document.body.style.overflow = 'hidden';
        
        // Handle sort selection
        sortModal.querySelectorAll('[data-sort]').forEach(btn => {
          btn.addEventListener('click', function() {
            const newSort = this.dataset.sort;
            if (sortSelect) {
              sortSelect.value = newSort;
              sortSelect.dispatchEvent(new Event('change'));
            }
            document.body.removeChild(sortModal);
            document.body.style.overflow = '';
          });
        });
        
        // Handle close
        sortModal.querySelector('.mobile-filter-close').addEventListener('click', function() {
          document.body.removeChild(sortModal);
          document.body.style.overflow = '';
        });
      });
    }
    
    // Close modal handlers
    [mobileFilterClose, mobileFilterModal].forEach(element => {
      if (element) {
        element.addEventListener('click', function(e) {
          if (e.target === this) {
            mobileFilterModal.classList.remove('show');
            document.body.style.overflow = '';
          }
        });
      }
    });
    
    // Clear all mobile
    if (mobileClearBtn) {
      mobileClearBtn.addEventListener('click', function() {
        clearAllFilters();
        updateMobileFilterButton();
      });
    }
    
    // Apply filters mobile
    if (mobileApplyBtn) {
      mobileApplyBtn.addEventListener('click', function() {
        mobileFilterModal.classList.remove('show');
        document.body.style.overflow = '';
        updateMobileFilterButton();
      });
    }
    
    // Update button state when filters change
    const originalFilterProducts = filterProducts;
    filterProducts = function() {
      originalFilterProducts();
      updateMobileFilterButton();
    };
  }
});
